// this file is NEXT APPLICATION CONFIG, ELECTRON CAN'T USE IT !!
import { getConfigValue } from '../lib/public-env/get-config-value';

export type RuntimeUrls = {
  rootDomain: string;
  gatewayUrl: string;
  portalAppUrl: string;
  authBaseUrl?: string;
};

export function getCurrentRootDomain(): string {
  return getCurrentRuntimeUrls().rootDomain;
}

function getCurrentRuntimeUrls(): RuntimeUrls {
  return createRuntimeUrls();
}

export function getCurrentGatewayUrl(): string {
  return getCurrentRuntimeUrls().gatewayUrl;
}

const hideProdDisplayDomains = new Set([
  'terra.security',
  'eu.terra.security',
  'tester.terra.security',
  'tester.eu.terra.security',
  'portal.terra.security',
]);

export function getDomainDisplayName(rootDomain: string): string {
  if (!rootDomain || hideProdDisplayDomains.has(rootDomain)) {
    return '';
  }
  return rootDomain;
}

function createRuntimeUrls(): RuntimeUrls {
  const portalAppUrl = getConfigValue('NEXT_PUBLIC_PORTAL_APP_URL') || '';
  const gatewayUrl = getConfigValue('NEXT_PUBLIC_API_GATEWAY_ADDRESS') || '';
  const authBaseUrl = getConfigValue('NEXT_PUBLIC_AUTH_BASE_URL') || '';

  const rootDomain = new URL(portalAppUrl).hostname;

  return {
    rootDomain,
    gatewayUrl,
    portalAppUrl,
    authBaseUrl,
  };
}
